import React from 'react'
import { AppBar, Dialog, IconButton, Toolbar, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import ItemRelatorio from '../ItemRelatorio'

export default function DialogRelatorios({ showDialog, setShowDialog, modelosRelatorios, dados, }) {
  const handleClose = () => {
    setShowDialog(false)
  }
  return (
    <>
      <Dialog open={showDialog}
        onClose={handleClose}>

        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Relatórios
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>


          </Toolbar>
        </AppBar>
        <div style={{ width: 500, height: 400, padding: 10 }}>
          <div style={{ display: 'flex', flexDirection: 'column', }}>
            {(modelosRelatorios || []).map((r, i) => <ItemRelatorio key={i} dados={dados} modelo={r} aoGerar={handleClose} />)}
          </div>
        </div>

      </Dialog>
    </>
  )
}
